/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";

     function appHeight() {
      var wh = $(window).innerHeight();
      document.documentElement.style
        .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $(document).on('click', '.nav-toggle', function(e){
        $(this).toggleClass('on');
        $('html').toggleClass('nav-open');
    });
    $(document).on('click', '.mobile-navigation nav ul.menu > li.menu-item-has-children > a', function(e){
        e.preventDefault();
        $(this).toggleClass('on').next().slideToggle();

    });
    $(document).on('click', '.h-events-filter a', function(e){
        e.preventDefault();
        var $item = $(this).data('item');
        var $fitem = $(this).data('filter');
        $('.h-events-filter a').removeClass('active');
        $('.'+$item).addClass('active');
        $('.h-events-item').fadeOut();
        setTimeout(function(){
            $('.'+$fitem).fadeIn();
        }, 400);
    });
    
    $('.image-cl-main').slick({
          dots: false,
          infinite: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 800,
          easing: 'ease-in-out',
          nextArrow: '<span class="slick-arrow slick-next"><svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" d="M6.15088 23.5L18.7269 12.374C18.7797 12.3271 18.8221 12.2695 18.8511 12.205C18.88 12.1406 18.895 12.0707 18.895 12C18.895 11.9293 18.88 11.8594 18.8511 11.795C18.8221 11.7305 18.7797 11.6729 18.7269 11.626L6.15088 0.5"/></svg></span>',
          prevArrow: '<span class="slick-arrow slick-prev"><svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" d="M18.8491 23.5L6.27312 12.374C6.22025 12.3271 6.17793 12.2695 6.14894 12.205C6.11996 12.1406 6.10497 12.0707 6.10497 12C6.10497 11.9293 6.11996 11.8594 6.14894 11.795C6.17793 11.7305 6.22025 11.6729 6.27312 11.626L18.8491 0.5"/></svg></span>',
    });
    $('.cs-gallery-main, .related-items-cl').slick({
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay: false,
          autoplaySpeed: 5000,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });
    $(window).on('load resize orientationchange', function() {
        var $carousel = $('.dbic-cards');
        if ($(window).width() > 992) {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else{
            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 7000,
                    cssEase: 'linear',
                     responsive: [
                        {
                          breakpoint: 992,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                          }
                        },
                        {
                          breakpoint: 600,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                          }
                        }
                      ]
                });
            }
        }
    });
    $('.inspiration-cl').slick({
        dots: true,
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'ease-in-out',
         responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });

    

    
    $(document).on('focus', '.ginput_container input:not(radio):not(checkbox)', function(){
        $(this).parents('.gfield').addClass("focussed");

    });
    $(document).on('blur', '.ginput_container input:not(radio):not(checkbox)', function(){
        $(this).parents('.gfield').removeClass("focussed");
    });

    function checkForInput(element) {
      // element is passed to the function ^
      var $element = '.ginput_container input:not(radio):not(checkbox)';
      var $label = $(element).parents('.gfield');

      if ($(element).val().length > 0) {
        $label.addClass('filled');
      } else {
        $label.removeClass('filled');
      }
    }

    // The lines below are executed on page load
    $('.ginput_container input:not(radio):not(checkbox)').each(function() {
      checkForInput(this);
    });

    // The lines below (inside) are executed on change & keyup
    $(document).on('change keyup', '.ginput_container input:not(radio):not(checkbox)', function() {
      checkForInput(this);  
    });
    $(document).bind('gform_post_render', function(){
         $('.ginput_container input:not(radio):not(checkbox)').each(function() {
          checkForInput(this);
        });

    });
    $(document).on('click', '.tab-items a', function(e){
        e.preventDefault();
        $('.tab-items a').removeClass('active');
        $(this).addClass('active');
        var currentTab = $(this).attr('href');
        $('.tab-content-item').removeClass('active');
        $(currentTab).addClass('active');
        return false;
    });
    

});